import { api } from "@/lib/api";

const QUEUE_KEY = "bocally_pos_offline_queue";
const CACHE_KEY = "bocally_pos_cache";

export const isNetworkError = (e) => !e?.response || e.code === "ERR_NETWORK" || e.message === "Network Error";

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(QUEUE_KEY) || "[]"); } catch { return []; }
}
export function saveQueue(q) { localStorage.setItem(QUEUE_KEY, JSON.stringify(q)); }

export function enqueueSale(payload) {
  const client_id = (typeof crypto !== "undefined" && crypto.randomUUID) ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const entry = { ...payload, client_id, offline_created_at: new Date().toISOString() };
  const q = getQueue();
  q.push(entry);
  saveQueue(q);
  const seq = Number(localStorage.getItem("bocally_pos_offline_seq") || 0) + 1;
  localStorage.setItem("bocally_pos_offline_seq", String(seq));
  return { ...entry, number: `OFFLINE-${String(seq).padStart(4, "0")}`, offline: true, vat_amount: Math.round(payload.total * 15 / 115 * 100) / 100 };
}

export function cacheCatalog(products, customers) {
  localStorage.setItem(CACHE_KEY, JSON.stringify({ products, customers, at: new Date().toISOString() }));
}
export function readCatalog() {
  try { return JSON.parse(localStorage.getItem(CACHE_KEY) || "null"); } catch { return null; }
}

let syncing = false;
export async function syncQueue() {
  const q = getQueue();
  if (!q.length || syncing) return null;
  syncing = true;
  try {
    const { data } = await api.post("/pos/transactions/sync", { transactions: q });
    const failed = data.results.filter((r) => r.status === "error");
    const failedIds = new Set(failed.map((r) => r.client_id));
    saveQueue(q.filter((t) => failedIds.has(t.client_id)));
    return { synced: data.results.filter((r) => r.status === "synced").length, duplicates: data.results.filter((r) => r.status === "duplicate").length, failed };
  } finally { syncing = false; }
}
